var OwnershipBlockMenuType={
  Hide:"Hide",
  DataType:"DataType",
  PanarayOwnerLists:"PanarayOwnerLists",
  FavoriteOwnerLists:'FavoriteOwnerLists',
  CreateOwnerLists:'CreateOwnerLists'
}
export default OwnershipBlockMenuType;
